// React Dependencies
import React, { Component } from 'react';

// External Dependencies
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Redirect } from 'react-router-dom';
import { Button, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

// Internal Dependencies
import { editPage, getMalls, getPage } from '../../../actions/admin/pageAction';
import { getOutlet, updateOutlet } from '../../../actions/admin/outlet';
import OpeningHours from '../openingHours/openingHours';
import Constants, { Colours } from '../../../common/constants';
import OverLoading from '../../global/OverLoading';
import { IsEmpty, IsValidWwwAndHttpUrl, IsValidHttpsUrl } from '../../../common/checks';
import { Trim } from '../../../common/util';
import MText from '../../common/MText';
import apiService from '../../../services.js/apiService';

class OutletInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading:             true,
      toUpdate:              false,
      exit:                  false,
      showOpeningHours:      false,
      postalCodesList:       [],
      selectedAddress:       null,
      showAddressesDropdown: false,
      formData:              {
        pageId:       '',
        name:         null,
        postalCode:   null,
        address:      null,
        unitNo:       '',
        lat:          null,
        lng:          null,
        tel:          '',
        locatedIn:    '',
        googleMapUrl: '',
        openingHours: {
          default:
            [
              {
                day:       'Monday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Tuesday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Wednesday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Thursday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Friday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Saturday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
              {
                day:       'Sunday',
                isOpen:    true,
                is24Hours: false,
                hours:     [],
              },
            ],
          eve: {
            isOpen:    true,
            is24Hours: false,
            hours:     [],
          },
          holiday: {
            isOpen:    true,
            is24Hours: false,
            hours:     [],
          },
          exceptions: [],
        },
      },
      uniqueOpenHours: [],
    };
  }

  getPageData = async (id) => {
    const page = await this.props.getPage(id);
    if (page) {
      this.props.editPage(page);
      this.modifyFormData('name', page.name);
      this.setState({ isLoading: false });
    }
  }

  fetchOutletData = async (id) => {
    try {
      const o = await this.props.getOutlet(id);
      const addresses = await apiService.getAddresses({ postalCode: o.postalCode });

      let address = null;
      if (!IsEmpty(addresses) && addresses.totalCount > 0) {
        address = addresses.rows.find((addr) => o.postalCode === addr.postalCode
            && o.address === addr.address
            && o.locatedIn === addr.name);
      }

      this.setState({
        formData: {
          name:         o.name,
          postalCode:   o.postalCode,
          address:      o.address,
          unitNo:       o.unitNo,
          lat:          o.lat,
          lng:          o.lng,
          tel:          o.tel,
          googleMapUrl: o.googleMapUrl,
          locatedIn:    IsEmpty(o.locatedIn) ? '' : o.locatedIn,
          openingHours: o.openingHours,
        },
        postalCodesList: !IsEmpty(addresses) ? addresses.rows : [],
        selectedAddress: !IsEmpty(address) ? address : null,
      }, function () {
        this.setOpeningHours(o.openingHours);
      });
    } catch (err) {
      toast.error(err);
    }
  }

  setOpeningHours = (data) => {
    this.setState({ showOpeningHours: true, formData: { ...this.state.formData, openingHours: data } }, () => {
      const self = this;
      setTimeout(() => { self.setState({ isLoading: false }); }, 300);
    });
  }

  setUniqueOpenHours = (data) => {
    this.setState({ formData: { ...this.state.formData, uniqueOpenHours: data } });
  }

  componentDidMount() {
    try {
      if (this.props.match.params.outletId) {
        this.state.toUpdate = true;
        this.fetchOutletData(this.props.match.params.outletId);
      } else {
        this.setState({ showOpeningHours: true });
        this.getPageData(this.props.match.params.id);
      }
    } catch (err) {
      toast.error(err);
    }
  }

  modifyFormData = (field, value) => {
    this.setState({ formData: { ...this.state.formData, [field]: value } });
  }

  onChange = (e) => {
    this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } });
  };

  onSelectPostalCode = (address) => {
    this.setState({
      formData: {
        ...this.state.formData,
        locatedIn: address.name || null,
        address:   address.address,
        lat:       address.lat,
        lng:       address.lng,
      },
      showAddressesDropdown: false,
      selectedAddress:       address,
    });
  }

  onChangePostalCode = (e) => {
    if (e) {
      this.setState({
        formData: {
          ...this.state.formData,
          postalCode: String(e.target.value).trim(),
        },
      }, async () => {
        const { postalCode } = this.state.formData;
        if (postalCode.length === 6) {
          this.setState({
            formData: {
              ...this.state.formData,
              locatedIn: null,
              address:   null,
              lat:       null,
              lng:       null,
            },
          });

          apiService.getAddresses({ postalCode })
            .then((result) => {
              if (!IsEmpty(result)) {
                if (result.totalCount === 0) {
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      locatedIn: null,
                      address:   null,
                      lat:       null,
                      lng:       null,
                    },
                    showAddressesDropdown: false,
                    postalCodesList:       [],
                  });
                } else if (result.totalCount === 1) {
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      locatedIn: result.rows[0].name || null,
                      address:   result.rows[0].address,
                      lat:       result.rows[0].lat,
                      lng:       result.rows[0].lng,
                    },
                    postalCodesList:       result.rows,
                    showAddressesDropdown: false,
                  });
                } else {
                  this.setState({
                    postalCodesList:       result.rows,
                    showAddressesDropdown: true,
                  });
                }
              } else {
                this.setState({
                  formData: {
                    ...this.state.formData,
                    locatedIn: null,
                    address:   null,
                    lat:       null,
                    lng:       null,
                  },
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.setState({
            postalCodesList: [],
            formData:        {
              ...this.state.formData,
              locatedIn: null,
              address:   null,
              lat:       null,
              lng:       null,
            },
          });
        }
      });
    }
  }

  onSubmit = async (e) => {
    this.setState({ isLoading: true });
    e.preventDefault();
    await this.child.onSubmit(e);
    const { id } = this.props.pageInView;
    try {
      if (IsEmpty(this.state.formData.address)) {
        return toast.error(Constants.Error.PostalCodeIsInvalid);
      }

      // trim name, locatedIn, googleMapUrl and set page id.
      const trimName = this.state.formData.name ? Trim(this.state.formData.name, false, true) : null;
      const trimLocatedIn = this.state.formData.locatedIn ? Trim(this.state.formData.locatedIn, false, true) : null;
      const trimGoogleMapUrl = this.state.formData.googleMapUrl ? Trim(this.state.formData.googleMapUrl, false, true) : null;

      // Validate the trimmed Google Map URL
      if (!IsEmpty(trimGoogleMapUrl) && !(IsValidWwwAndHttpUrl(trimGoogleMapUrl) || IsValidHttpsUrl(trimGoogleMapUrl))) {
        toast.error(`Link "${trimGoogleMapUrl}" should be a valid URL`);
        return;
      }

      const updatedFormData = { ...this.state.formData, name: trimName, locatedIn: trimLocatedIn, googleMapUrl: trimGoogleMapUrl, pageId: id };
      this.setState({ formData: updatedFormData });

      if (this.state.toUpdate) {
        await this.props.updateOutlet(this.props.match.params.outletId, updatedFormData);
      } else {
        await apiService.addOutlet(updatedFormData);
      }

      if (this.state.toUpdate) {
        toast.success('Outlet updated.');
      } else {
        toast.success('Outlet added.');
        this.setState({ exit: true });
      }

      this.setState({ isLoading: false });
    } catch (err) {
      toast.error(err);
    }
  }

  render() {
    const setOpeningHoursData = this.state.formData.openingHours;
    return (this.state.exit ? <Redirect to={`/admin/page/${this.props.pageInView.id}/outlets`} />
      : (
        <div>
          {this.state.isLoading && <OverLoading />}
          <div>
            <form onSubmit={(e) => this.onSubmit(e)} className="form position-relative">
              <div className="row">
                <div className="col-lg-6 col-sm-12 form-section">
                  {this.state.toUpdate === false && <h3 style={{ paddingBottom: 10 }}>Add Outlet</h3>}
                  <div className="form-group">
                    <label>Outlet Name</label>
                    <input
                      required
                      className="form-control"
                      name="name"
                      value={this.state.formData.name}
                      onChange={(e) => this.onChange(e)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Postal Code</label>
                    <Autocomplete
                      options={this.state.postalCodesList}
                      freeSolo
                      size="small"
                      value={this.state.selectedAddress}
                      open={this.state.showAddressesDropdown}
                      onFocus={() => {
                        this.setState((prev) => ({ showAddressesDropdown: prev.postalCodesList.length >= 2 }));
                      }}
                      onBlur={() => this.setState({ showAddressesDropdown: false })}
                      popupIcon={false}
                      getOptionLabel={(option) => option.postalCode}
                      onInputChange={(e) => this.onChangePostalCode(e)}
                      onChange={(e, value) => {
                        if (value) {
                          this.onSelectPostalCode(value);
                        }
                      }}
                      renderOption={(option) => (
                        <li key={option.id}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <MText text={option.name} bold={600} />
                            <MText text={option.address} colour={Colours.Grey} size={12} />
                          </div>
                        </li>
                      )}
                      renderInput={(params) => <TextField {...params} variant="outlined" />}
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Located in Mall
                      {' '}
                      <span style={{ fontStyle: 'italic' }}>(*Inform IT if Mall info is not populated correctly)</span>
                    </label>
                    <input
                      className="form-control"
                      name="locatedIn"
                      value={this.state.formData.locatedIn || ''}
                      onChange={(e) => this.onChange(e)}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <input
                      required
                      className="form-control"
                      name="address"
                      value={this.state.formData.address || Constants.Error.PostalCodeIsInvalid}
                      onChange={(e) => this.onChange(e)}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label>Unit No. #</label>
                    <input
                      className="form-control"
                      name="unitNo"
                      value={this.state.formData.unitNo}
                      onChange={(e) => this.onChange(e)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Tel</label>
                    <input
                      className="form-control"
                      name="tel"
                      value={this.state.formData.tel}
                      onChange={(e) => this.onChange(e)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Google Map Url</label>
                    <input
                      className="form-control"
                      name="googleMapUrl"
                      value={this.state.formData.googleMapUrl}
                      onChange={(e) => this.onChange(e)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-sm-12 col-xs-12 form-section">
                  <h3 style={{ paddingTop: 20, paddingBottom: 10 }}>Manage Opening Hours</h3>
                  {
                    this.state.showOpeningHours
                    && (
                      <OpeningHours
                        childRef={(ref) => (this.child = ref)}
                        dataOpening={setOpeningHoursData}
                        setUniqueOpenHours={(e) => { this.setUniqueOpenHours(e); }}
                        set={this.setOpeningHours}
                        match={this.props.match}
                        params={this.props.match.params}
                        id={this.props.match.params.id}
                      />
                    )
                  }
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 col-sm-12 form-section">
                  <Button type="submit" variant="contained" color="primary" style={{ width: '100%', marginTop: '30px' }} disabled={this.state.isLoading}>{this.state.toUpdate === true ? 'Save' : 'Add'}</Button>
                  {
                    this.state.toUpdate === true
                    && (
                      <p
                        className="text-center mt-4"
                        style={{ cursor: 'pointer', color: '#000' }}
                        onClick={() => { this.setState({ exit: true }); }}
                      >
                        Back to Outlets
                      </p>
                    )
                  }
                </div>
              </div>

            </form>
          </div>
        </div>
      )
    );
  }
}

OutletInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id:       PropTypes.number,
      outletId: PropTypes.number,
    }),
  }).isRequired,
  pageInView: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,

  getOutlet:    PropTypes.func.isRequired,
  getPage:      PropTypes.func.isRequired,
  editPage:     PropTypes.func.isRequired,
  getMalls:     PropTypes.func.isRequired,
  updateOutlet: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

const mapDispatchToProps = (dispatch) => ({
  getOutlet:    (pageId, outletId) => dispatch(getOutlet(pageId, outletId)),
  getPage:      (id) => dispatch(getPage(id)),
  editPage:     (page) => dispatch(editPage(page)),
  getMalls:     () => dispatch(getMalls()),
  updateOutlet: (id, data) => dispatch(updateOutlet(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutletInfo);
